<template>
  <div class="content-wrapper">
    <app-overlay-loader v-if="preloader" />
    <form
      ref="form"
      data-url="complaints/register/storeFile700/"
      :class="{ 'loading-opacity': preloader }"
      enctype="multipart/form-data"
    >
      <div class="row">
        <div class="col-md-6">
          <label>Oficio de la Queja <span class="color_import">*</span></label>
          <app-input
            type="file"
            :label="inputs.file_c ? inputs.file_c.name : $t('upload_your_file')"
            v-model="inputs.file_c"
            :required="true"
            v-if="!inputs.complaint_document_oec"
          />

          <div class="mt-2">
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="openTab(inputs, 'complaint_document_oec')"
              v-if="inputs.complaint_document_oec"
            >
              <app-icon name="file" />
              {{ $t("view") }}
            </button>

            <button
              type="submit"
              class="btn btn-danger"
              @click.prevent="openDeleteModal('complaint_document_oec')"
              v-if="inputs.complaint_document_oec"
            >
              <app-icon name="trash-2" />
              {{ $t("delete") }}
            </button>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 mt-4">
          <div class="form-group">
            <label
              >Anexos adicionales<b
                class="text-danger ml-2"
                style="font-size: 18px !important"
                >*</b
              ></label
            >
            <app-input type="dropzone" v-model="files_1" />

            <p class="text-center text-danger mt-2">
              <small>
                <strong>Tamaño máximo de cada archivo 8MB</strong>
              </small>
            </p>
          </div>
        </div>

        <div class="col-md-6">
          <table class="table table-sm table-striped mt-2">
            <thead>
              <tr>
                <th scope="col">NOMBRE</th>
                <th scope="col" class="text-center" style="width: 20%">
                  ACCIÓN
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(value, key) in inputs.attach_complaint_document_oec"
                :key="key"
              >
                <td class="align-middle">
                  <small class="text-primary">{{
                    value.path.split("/")[value.path.split("/").length - 1]
                  }}</small>
                </td>
                <td class="align-middle text-center">
                  <div class="mt-2">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="
                        openTab(inputs.attach_complaint_document_oec, key)
                      "
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="row">
        <div class="col-12 mt-3">
          <button
            type="submit"
            class="btn btn-primary mr-2"
            @click.prevent="submit"
          >
            {{ $t("save") }}
          </button>
        </div>
      </div>

      <app-confirmation-modal
        v-if="deleteModal"
        modal-id="delete"
        @confirmed="confirmed"
        @cancelled="cancelled"
        title="Confirmación"
        message="¿Desea eliminar este archivo?"
      />
    </form>
  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";

export default {
  mixins: [FormMixin],

  props: {
    evalTestId: String,
    dgc_complaint_document: Object,
  },
  data() {
    return {
      preloader: false,
      deleteModal: false,
      inputs: {},
      files_1: [],
    };
  },
  created() {
    this.loadForm();
    this.getData();
  },

  methods: {
    beforeSubmit() {
      this.preloader = true;
    },
    submit() {
      if (this.files_1.length > 0 && this.validateFileSize(this.files_1) > 0) {
        this.$toastr.e("El tamaño maximo permitido de cada archivo es de 8MB");
        return;
      }

      let formData = new FormData();
      for (const [key, value] of Object.entries(this.inputs)) {
        formData.append(key, value);
      }
      this.files_1.forEach((file) => {
        formData.append("files_1[]", file);
      });

      this.save(formData);
    },
    afterSuccess(res) {
      // this.$toastr.s(res.data.message);
      this.preloader = false;
      this.inputs = res.data.data;
      this.$toastr.s(this.$t("complaint_success"));
      this.files_1 = [];
    },

    openTab(obj, fileName) {
      const w = window.open(obj[fileName].path, "_blank");
      w.focus();
    },

    openDeleteModal(fileName) {
      this.selected = fileName;
      this.deleteModal = true;
    },
    confirmed() {
      this.inputs[this.selected] = null;
    },
    cancelled() {
      this.deleteModal = false;
    },
    loadForm() {
      if (this.$store.state.evaluatorReview.evalTest) {
        this.inputs = {
          evalTestId: this.$store.state.evaluatorReview.evalTest.id,
          complaint_document_oec:
            this.$store.state.evaluatorReview.evalTest.complaint_document_oec,
          complaint_document_oec_anexo:
            this.$store.state.evaluatorReview.evalTest
              .complaint_document_oec_anexo,
        };
      }
    },
    getData() {
      let url = `complaints/register/${this.$store.state.evaluatorReview.evalTestId}?tab=Carga%20de%20Documentos`;
      this.axiosGet(url).then((response) => {
        this.inputs = response.data;
      });
    },
    validateFileSize(files) {
      return files.filter((file) => {
        if (file.size > 8000000) {
          return file;
        }
      }).length;
    },
  },
};
</script>

<style></style>
